export enum InventoryStatus {
  QUOTE_PENDING = "Quote Pending",
  DATA_DESTRUCTION = "Erasure",
  WAITING_COLLECTION = "Waiting Collection",
  COMPLETE = "Complete",
  SOLD = "Sold",
  READY_FOR_DISPOSAL = "Ready for Disposal",
}
